import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Note, NoteEntityType } from '../model/note';

interface GetNotesResponse {
  notes: Array<Note>;
  total: number;
  page: string;
  limit: string;
  totalPages: number;
}

interface GetNotesParams {
  entityId: string;
  entityType: NoteEntityType;
  limit: number;
  page: number;
}

export const getAllNotesAPI = async (params: GetNotesParams) => {
  const response = await baseAPI.get<GetNotesResponse>(`/notes/all`, {
    params,
  });
  return response.data;
};

export const useGetAllNotes = (params: GetNotesParams) => {
  return useQuery({
    // Include entity scope — a bare KEYS.NOTES key reused sibling notes (ENR-4054 smoke).
    queryKey: [
      KEYS.NOTES,
      params.entityId,
      params.entityType,
      params.page,
      params.limit,
    ],
    queryFn: () => getAllNotesAPI(params),
    enabled: !!params.entityId,
  });
};
